var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearchSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90906 2.0011C5.93814 2.0011 4.98903 2.28901 4.18173 2.82842C3.37444 3.36784 2.74524 4.13453 2.37368 5.03154C2.00213 5.92856 1.90491 6.9156 2.09433 7.86787C2.28375 8.82013 2.75129 9.69484 3.43783 10.3814C4.12438 11.0679 4.99909 11.5355 5.95135 11.7249C6.90362 11.9143 7.89067 11.8171 8.78768 11.4455C9.68469 11.074 10.4514 10.4448 10.9908 9.63749C11.5302 8.8302 11.8181 7.88108 11.8181 6.91016C11.818 5.60822 11.3008 4.35963 10.3802 3.43902C9.45959 2.51841 8.211 2.00118 6.90906 2.0011V2.0011Z",
    stroke: "#9E9E9E",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8184 10.5726L15.2482 14.0025",
    stroke: "#9E9E9E",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchSecondary);
export default __webpack_public_path__ + "static/media/ic-search-secondary.6f6b4f98710ec7c1628da928d5b14111.svg";
export { ForwardRef as ReactComponent };